import { Flex, Box, Text, Tooltip, Badge, Stack } from "@mantine/core";
import { useContext } from "react";
import SingleCustomerContext from '../../Customer-Context/SingleCustomerContext';
import { LIGHT_BLUE_CELL, ORGS_RELATED_TO_IDEA_BACKGROUND, PRIMARY_BLUE } from '../../../../constants/colors';
import { formatBigMonetaryValue } from '../../../ideaNiv/Funcs';
import { getNestedFieldValue } from '../../../ideaNiv/helpers/calculateImpactResults';
import {IconBulb} from '@tabler/icons'
import { IdeasIconCustomer } from "../../../../icons/x-symbol-svgrepo-com";

interface CountCellProps {
  record: any;
  groupBy: string;
  statuses: string[];
  sortedIdeas: any[];
}

export function CountCell({ record, groupBy, statuses, sortedIdeas }: CountCellProps) {
  const { customers, impactAggregationProperties } = useContext(SingleCustomerContext);

  // Filter ideas for the current group
  const ideasForThisGroup = sortedIdeas.filter(idea => idea[groupBy] === record._id);
  
  // Filter by column statuses
  const ideasInThisColumn = ideasForThisGroup.filter(idea => 
    statuses.some((statusValue: string) => 
      idea.status?.toLowerCase() === statusValue.toLowerCase()
    )
  );

  // Calculate totalMainImpact and orgsRelatedToIdeaCount for all ideas in this column
  const mainImpactProperty = impactAggregationProperties?.find((property: any) => property?.impact?.isMainImpact);
  const fieldPath = mainImpactProperty?.fieldPath;
  const mainImpactLabel = mainImpactProperty?.label
  // Calculate total main impact for all ideas in this column
  const totalMainImpact = ideasInThisColumn.reduce((sum: number, idea: any) => {
    const evidences = idea?.evidences || [];
    const ideaImpact = evidences.reduce((evidenceSum: number, evidence: any) => 
      evidenceSum + (getNestedFieldValue(evidence, fieldPath) || 0), 0
    );
    return sum + ideaImpact;
  }, 0);

  // Calculate orgsRelatedToIdeaCount for all ideas in this column
  const allEvidences = ideasInThisColumn.flatMap((idea: any) => idea?.evidences || []);
  const allIdeaOrgIds = allEvidences.map((evidence: any) => evidence?.orgId);
  const uniqueOrgIds = Array.from(new Set(allIdeaOrgIds)); // Remove duplicates
  const orgsRelatedToIdea = customers?.filter((customer: any) => uniqueOrgIds.includes(customer?._id));
  const orgsRelatedToIdeaCount = orgsRelatedToIdea?.length || 0;
  
  return (
    <Flex justify='center' w='100%'>
      {ideasInThisColumn.length > 0 ? <Flex
        w='80%'
        h={24}
        p={4}
        sx={{
          borderRadius: 30,
          backgroundColor: LIGHT_BLUE_CELL,
        }}
        align="center"
        justify="space-between"
      >
        <Box
          sx={{
            width: 20,
            height: 18,
            borderRadius: '50%',
            backgroundColor: ORGS_RELATED_TO_IDEA_BACKGROUND,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            marginRight: 4,
          }}
        >
          <Tooltip label={'# of customers'} withinPortal>
            <Text size="sm" weight={500} color='white' >
              {orgsRelatedToIdeaCount}
            </Text>
          </Tooltip>
        </Box>
        <Box  maw={60} >
          <Tooltip label={mainImpactLabel} withinPortal>
            <Text size="sm" weight={500} color={PRIMARY_BLUE}>
              {formatBigMonetaryValue(totalMainImpact)}
            </Text>
          </Tooltip>
        </Box>
     
         
        
        <Badge ml={4} sx={{border: `1px solid ${ORGS_RELATED_TO_IDEA_BACKGROUND}` }} m={0} p={3} variant="filled" /* color={ORGS_RELATED_TO_IDEA_BACKGROUND} */ styles={{
          root: {
            backgroundColor: LIGHT_BLUE_CELL,
            color: 'white'
          }
        }} size="xs">
          <Tooltip label={'# of Ideas'} withinPortal>
            <Flex align='center'>
              <Text size="sm" weight={500} color={PRIMARY_BLUE} mr={3} >
                {ideasInThisColumn.length}
              </Text>
              <Stack align="center" justify="center"> 
             
                {/* <IconBulb color={PRIMARY_BLUE} size={11}/> */}
                <IdeasIconCustomer height={12}  width={12}/>  
              
              </Stack> 
            </Flex>
            
          </Tooltip>
        </Badge>
        
        {/* <Box mr={8}>
          <Tooltip label='Ideas' withinPortal>
            <Flex>
              <Stack align="start" justify="end">
                <Indicator size={5}>
                  <IdeasIconCustomer height={12}  width={12}/> 
                </Indicator>
              </Stack>
              
      
            </Flex>
            
          </Tooltip> 
          
        </Box> */}
          
        
      </Flex>: <></>}

      
     
    </Flex>
  );
} 